// Minimal Filemoon helper to normalize watch/page URLs into embed URLs with autoplay
// Expects REACT_APP_FILEMOON_API_KEY or NEXT_PUBLIC_FILEMOON_API_KEY if API usage is needed later

const KEY = process.env.REACT_APP_FILEMOON_API_KEY || process.env.NEXT_PUBLIC_FILEMOON_API_KEY || '';

export function getKey() { return KEY; }

// Accepts various Filemoon URL shapes and returns an embeddable URL with autoplay when possible
export function toEmbedAutoplay(url) {
  if (!url) return '';
  try {
    const u = new URL(url, window.location.origin);
    // Common hostnames: filemoon.sx, filemoon.wf, filemoon.in etc.
    // Normal watch URLs often contain /e/<id> or /v/<id> or /d/<id>
    // Embed base typically /e/<id>
    let pathname = u.pathname || '';
    const parts = pathname.split('/').filter(Boolean);
    let id = '';
    if (parts.length >= 2) {
      // e/<id> or v/<id> or d/<id>
      id = parts[1];
    } else if (parts.length === 1) {
      id = parts[0];
    }
    if (!id) return url;
    const embed = `${u.protocol}//${u.host}/e/${id}`;
    const qs = new URLSearchParams(u.search || '');
    // force autoplay if supported
    qs.set('autoplay', '1');
    // some players also respect autostart
    qs.set('autostart', '1');
    return `${embed}?${qs.toString()}`;
  } catch {
    return url;
  }
}

// Best-effort: attempt to start playback at a given second mark.
// Tries common query keys used by various hosts; if unsupported, player will ignore them.
export function toEmbedWithStart(url, seconds) {
  const base = toEmbedAutoplay(url);
  const sec = Math.max(0, Math.floor(Number(seconds) || 0));
  if (!sec) return base;
  try {
    const u = new URL(base, window.location.origin);
    const qs = u.searchParams;
    qs.set('t', String(sec));
    qs.set('start', String(sec));
    qs.set('time', String(sec));
    u.search = qs.toString();
    // also try hash time for raw media players (harmless if ignored)
    if (!u.hash) u.hash = `t=${sec}`;
    return u.toString();
  } catch {
    return base;
  }
}
